import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { questionMark } from 'containers/inProgressPage/subcomponents/stock/questionMark';
import styled from 'styled-components';

export const VideoDurationTimer = ({ timer }) => {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);

  const formatTime = seconds => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <VideoDurationTimerContainer>
      {t('videoQuestion.videoDurationRemaining', { time: formatTime(timer) })}
      <QuestionMark
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
      >
        {questionMark}
        {showTooltip && (
          <Tooltip>
            <TooltipContent>
              <p>{t('videoQuestion.countdownExplanation')}</p>
              <WarningSection>
                <span>⚠️ {t('videoQuestion.sectionTimerWarning')}</span>
              </WarningSection>
            </TooltipContent>
            <TooltipArrow />
          </Tooltip>
        )}
      </QuestionMark>
    </VideoDurationTimerContainer>
  );
};

const VideoDurationTimerContainer = styled.div`
  font-size: 18px;
  align-self: center;
  display: flex;
  gap: 4px;
`;

const QuestionMark = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
  padding-bottom: 4px;
  position: relative;
  cursor: pointer;
  svg {
    width: 16px;
    height: 16px;
  }
`;

const Tooltip = styled.div`
  position: absolute;
  top: 100%;
  left: -10px;
  z-index: 1000;
  margin-top: 8px;
`;

const TooltipContent = styled.div`
  background-color: #001730;
  color: white;
  padding: 2px 12px;
  border-radius: 4px;
  width: 360px;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  p {
    margin: 0 0 8px 0;
  }
`;

const WarningSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 8px;
`;

const TooltipArrow = styled.div`
  position: absolute;
  top: -6px;
  left: 12px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #001730;
`;
